<template>
  <v-container>
    <v-card-title class="text--center"> </v-card-title>
    <v-card>
      <v-card-title>
        Gestion de publications
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          @keyup.enter="filterKey"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-skeleton-loader :loading="loading && !options.page" type="table">
        <v-data-table
          :loading="loading"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          loading-text="Veuillez patienter quelques instants "
          :search="search"
          @page-count="pageCount = $event"
          :options.sync="options"
          :server-items-length="totalDocuments"
          :headers="headers"
          :items="dataValues"
          hide-default-footer
          class="elevation-0"
        >
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-spacer></v-spacer>
              <v-dialog v-model="dialogs" max-width="500px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    fab
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                    ><v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <v-sheet elevation="12" class="pa-12">
                  <v-form
                    class="input--fields__wrapper"
                    ref="create"
                    lazy-validation
                    v-on:submit.prevent="onCreate"
                  >
                    <v-text-field
                      :rules="[rules.required]"
                      label="Title"
                      v-model="editedItem.publicationTitle"
                    ></v-text-field>

                    <v-file-input
                      :rules="[rules.required]"
                      id="fUpload"
                      accept="application/pdf"
                      v-model="files"
                      placeholder="Upload"
                      label="Pièces jointes"
                      prepend-icon="mdi-paperclip"
                    >
                      <template v-slot:selection="{ text, item, selected }">
                        <v-chip
                          :rules="[rules.required]"
                          :input-value="selected"
                          close
                          @click:close="remove(item)"
                          small
                          label
                          color="primary"
                        >
                          {{ text }}
                        </v-chip>
                      </template>
                    </v-file-input>

                    <v-overlay :value="overlay">
                      <v-progress-circular
                        indeterminate
                        size="64"
                      ></v-progress-circular>
                    </v-overlay>
                  </v-form>
                </v-sheet>

                <v-btn color="primary" @click="onCreate" tile>Créer</v-btn>
              </v-dialog>
            </v-toolbar>
          </template>

          <template v-slot:item.publicationFile="{ item }">
            <v-btn
              @click="url(item)"
              class="text-capitalize"
              color="primary"
              rounded
            >
              Consulter
            </v-btn>
          </template>
          <template v-slot:item.delete="{ item }">
            <v-icon medium class="ml-5" @click="deleteItem(item)">
              mdi-delete
            </v-icon>
          </template>
        </v-data-table>
      </v-skeleton-loader>

      <div class="class text-center pt-2">
        <v-pagination
          circle
          :total-visible="7"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
  components: {},

  methods: {
    resetCreate() {
      this.$refs.create.reset();
    },
    resetUpdate() {
      this.$refs.update.reset();
    },
    checkRendering() {
      this.$store.state.toRender = true;
    },
    url(item) {
      window.open(`${item.publicationFile.fileLocation}`);
    },
    ApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store.dispatch('medias/getPublication', page).then((resp) => {
        this.loading = false;

        this.dataValues = resp.data.allPublications;
        this.dataValues.forEach((document) => {
          document.releaseDate = moment(document.releaseDate).format(
            'YYYY/MM/DD'
          );
        });
        this.totalDocuments = resp.data.totalNumber;
        this.itemsPerPage = resp.data.limit;
      });
    },
    FilterApiCall() {
      this.loading = true;
      const { page } = this.options;
      this.$store
        .dispatch('medias/searchPublication', {
          page: page,
          searchData: this.search,
        })
        .then((resp) => {
          this.loading = false;

          this.dataValues = resp.data.allPublications;
          this.dataValues.forEach((document) => {
            document.releaseDate = moment(document.releaseDate).format(
              'YYYY/MM/DD'
            );
          });
          this.totalDocuments = resp.data.totalNumber;
        });
    },

    filterKey(event) {
      if (event.keyCode === 13) {
        this.FilterSort();
      }
    },

    extension_checker(tag) {
      const file = document.querySelector(tag);

      for (let index = 0; index < file.files.length; index++) {
        if (/\.(pdf|)$/i.test(file.files[index].name) === false) {
          //change the alert with a function that throws a snackbar or smtng
          alert('only pdf extensions ar supported');
          return false;
        } else {
          return true;
        }
      }
    },

    deleteItem(item) {
      this.overlay = true;
      confirm('Are you sure you want to delete this item?') &&
        this.$store
          .dispatch('medias/deletePublication', { _id: item._id })
          .then((resp) => {
            this.ApiCall();
            this.overlay = false;
          });
    },

    onCreate() {
      if (this.$refs.create.validate()) {
        let formData = new FormData();

        if (this.files !== null) {
          formData.append('files', this.files, this.files.name);
        }

        // initial values for other inputs
        formData.append('publicationTitle', this.editedItem.publicationTitle);

        this.overlay = true;

        axios({
          url: '/api/ENH5ZL4T64ZK88EH4RGZ/createPublication',
          method: 'POST',
          data: formData,
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
        })
          .then((response) => {
            this.ApiCall();
            this.resetCreate();
            this.overlay = false;

            this.dialogs = false;
          })
          .catch((error) => {});
      }
    },

    FilterSort() {
      if (this.search !== null) {
        this.FilterApiCall();
      } else {
        return false;
      }
    },
  },
  computed: {
    test() {
      return this.$store.state.appels.obj;
    },
  },

  mounted() {
    this.loading = false;
  },

  watch: {
    options: {
      handler() {
        if (this.search !== null) {
          this.FilterApiCall();
        } else {
          this.ApiCall();
        }
      },
      deep: true,
    },
  },

  data: () => ({
    overlay: false,

    search: null,

    rules: {
      required: (value) => !!value || 'Ce champ est obligatoire.',
      min: (v) =>
        v.length >= 8 || 'Le champ doit contenir 8 caractères minimum',
      emailRules: (v) =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        'Veuillez entrer une adresse électronique valide',
    },

    _id: '',
    callOfferNumber: '',
    callStatus: '',
    callOfferNumber: '',
    callOfferDescription: '',
    EstimationPrice: '',
    depotDate: '',
    fileFees: '',
    visiteDate: '',
    callProvisionary: '',
    OpenDate: '',

    loading: true,

    options: {},
    totalDocuments: 0,
    itemsPerPage: 10,
    page: 1,
    pageCount: 0,
    editedIndex: -1,
    dialog: false,
    defaultItem: {
      _id: '',
      releaseTitle: '',
    },
    editedItem: {
      _id: '',
      publicationTitle: '',
    },
    headers: [
      {
        text: 'Titre',
        value: 'publicationTitle',
      },
      { text: 'Fichier', value: 'publicationFile' },
      { text: 'Supprimer', value: 'delete' },
    ],
    dataValues: [],
    overlay: false,
    flex: [4, 6, 3],
    show: false,

    items: ['Attribué', 'En cours', 'Infructueux', 'Annulé'],

    // Details update

    files: null,
    detailId: '',
    detailEtat: '',
    detailDateOpening: '',
    detailEstimation: '',
    detailDateEchant: '',
    detailFrais: '',
    detailDateVisite: '',
    detailCautionnement: '',
    detailObjetAppel: '',
  }),
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap');

.input--fields__container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
}

.class {
  background-color: white;
}

.v-chip {
  width: 100px;
  justify-content: center;
}

/* Dialog Styling */

.round {
  border-radius: 30px;
  overflow-y: hidden;
}

@media only screen and (device-width: 1920px) and (device-height: 1080px) {
  .v-card {
    margin-left: 26px !important;
    width: 91%;
  }
}
</style>
